//var BasketSettings = (function (_api) {
//    var _settings = {};
//	var _ready = new $.Deferred();

//    $(function () {
//        var pagesettings = $('@basket').data('settings');

//		if (pagesettings.CheckoutViewMobileEnabled === true) {
//            _api.checkoutView().done(function (data) {
//                _settings = data.Value || {};
//                _ready.resolve(_settings);
//            });
//        } else {
//            _ready.resolve(_settings);
//        }
//    });

//    return {
//		ready: function () {
//            return _ready.promise();
//        },
//        get: function (name) {
//            if (name) {
//                return _settings[name];
//            }
//            return _settings || {};
//		},
//		set: function (name, value) {
//            return _settings[name] = value;
//        }
//    }
//})(api);

var CheckoutSettings = {

    $ready: new $.Deferred(),

	_get: function () {
		var settings = $('@basket').data('settings') || {};
        return settings;
    },

	getBasketSettings: function () {
        var settings = this._get();
		if (app.settings.get('UseGuestCheckout') && !window.__isAuthorized__()) {
            settings.UseIPay = false;
            settings.UseMasterPass = false;
        }
        return settings;
	},

	getDecoration: function () {
		var data = $('@basket').data('decoration') || {};
		return data.DecorationInfo;
	},

	OrderPaymentType: {
		None: 'None',
		IpPayments: 'IpPayments',
		PayPalExpress: 'PayPalExpress',
		PayPalWebPro: 'PayPalWebPro',
		TNSPayments: 'TNSPayments',
		NabPayments: 'NabPayments',
		KPayments: 'KPayments',
		MasterPassPayment: 'MasterPassPayment',
		IPay88Payments: 'IPay88Payments',
		CyberSourcePayments: 'CyberSourcePayments',
		ENetsPayments: 'ENetsPayments',
		CashflowsPayments: 'CashflowsPayments',
		PayPalEbay: 'PayPalEbay',
		BrainTree: 'BrainTree',
		OurpaySelect: 'OurpaySelect',
		BrainTreePayPal: 'BrainTreePayPal',
		GraysEcommerce: 'GraysEcommerce',
		PromoVoucher: 'PromoVoucher',
		RefundVoucher: 'RefundVoucher',
		ImportedFromBIV: 'ImportedFromBIV',
		VisaCheckoutCS: 'VisaCheckoutCyberSource',
		Stripe: 'Stripe'
	},

	PaymentOption: {
	    None: 'None',
	    MasterPassPayment: 'MasterPassPayment',
	    IPay88Payments: 'IPay88Payments',
	    BrainTree: 'BrainTree',
	    BrainTreePayPal: 'BrainTreePayPal',
	    BrainTreePayPalCredit: 'BrainTreePayPalCredit',
        VisaCheckoutBrainTree: 'VisaCheckoutBrainTree',
	    VisaCheckoutCyberSource: 'VisaCheckoutCyberSource',
        OurPay: 'OurPay',
		AfterPay: 'Afterpay',
		OpenPay: 'Openpay',
	    Humm: 'Humm',
		Stripe: 'Stripe',
        ZipPayAU: 'ZipPayAU',
		ZipPayNZ: 'ZipPayNZ',
		LPay: 'LatitudePay',
        Klarna: 'Klarna'
	},

	PaymentSystemType: {
	    braintree: 'braintree',
	    mypay: 'mypay',
	    stripe: 'stripe'
	},

	PaymentType: {
		None: 'None',
		Direct: 'Direct',
		Visa: 'Visa',
		MasterCard: 'MasterCard',
		Discover: 'Discover',
		Amex: 'Amex',
		JCB: 'JCB',
		PayPal: 'PayPal',
		MasterPass: 'MasterPass',
		VisaCheckoutCS: 'VisaCheckoutCyberSource',
		VisaCheckoutBT: 'VisaCheckoutBrainTree'
    },

    PaymentTypeToPaymentOptions: {
        None: 'None',
        Visa: 'BrainTree',
        MasterCard: 'BrainTree',
        Discover: 'BrainTree',
        Amex: 'BrainTree',
        JCB: 'BrainTree',
        PayPal: 'BrainTreePayPal',
        MasterPass: 'MasterPassPayment',
        VisaCheckoutCyberSource: 'VisaCheckoutCyberSource',
        VisaCheckoutBrainTree: 'VisaCheckoutBrainTree'
    },

	addressDeliveryTypes: {
		signature: 'This delivery type allows customer to choose only signature point',
		pickup: 'This delivery type allows customer to choose only pickup point'
	},

	templateNames: {
		subtotal: '_Subtotal',
		delivery: '_Delivery',
		tax: '_Tax',
		vouchers: 'mobile_vouchers',
        total: '_TotalOrder',
        totalWithSelect: '_TotalOrder',
        select: '_DeliveryOption_OURPAYSELECT_Title'
	},

	MyPayRejectionCodes: {
		outOfRange: 'mypay_payment_amount_out_of_range',
		exceededDebtLimit: 'mypay_customer_exceeded_debt_limit',
		untrusted: 'mypay_customer_untrusted',
		invalidPaymentMethod: 'mypay_invalid_payment_method'
	},

	spinnerTimeout: 2000,

	imageSize: 200,
	// maxItemsToPurchaseCount: 5,

	Validation: {
		Delivery: 'delivery',
		GiftAddress: 'giftAddress',
		BillingAddress: 'billingAddress',
		GiftBillingAddress: 'giftBillingAddress',
		TermsAndConditions: 'termsandconditions',
		TermsAndConditionsOurPay: 'termsourpay',
        TermsAndConditionsOurPaySelect: 'termsourpayselect',
		AgeRestricted: 'agerestricted',
		ShippingAvailability: 'shippingAvailability'
	},

	paymentServiceErrorTypes: {
		threeDS: '3DS error type occurs when something wrong with 3DS'
	},

	resolve: function (data) {
		var s = this._get();
        var ourpay = data.Value.OurPay;
		var isOurPayEnabled = ourpay && ourpay.Settings.IsOurPayEnabled || false;
		var isStripeEnabled = s.StripeEnabled && (!isOurPayEnabled || s.StripeEnabledWithOurPay);

        //BasketSettings.set("StripeEnabled", isStripeEnabled);

		this.$ready.resolve();
    },

    ready: function(func) {
        this.$ready.done(_.bind(function() {
            func(this.getBasketSettings());
        }, this));
    }
};

var braintreeSupportedTypes = {
    card: [
        CheckoutSettings.PaymentType.Visa,
        CheckoutSettings.PaymentType.MasterCard,
        CheckoutSettings.PaymentType.Discover,
        CheckoutSettings.PaymentType.Amex,
        CheckoutSettings.PaymentType.JCB
    ],
    paypal: [CheckoutSettings.PaymentType.PayPal]
};

var braintreeSupportedOrderTypes = {
    card: [CheckoutSettings.OrderPaymentType.BrainTree],
    paypal: [CheckoutSettings.OrderPaymentType.BrainTreePayPal]
};

var stripeSupportedTypes = {
    card: [
        CheckoutSettings.PaymentType.Visa,
        CheckoutSettings.PaymentType.MasterCard,
        CheckoutSettings.PaymentType.Discover,
        CheckoutSettings.PaymentType.Amex,
        CheckoutSettings.PaymentType.JCB
    ]
};

var stripeSupportedOrderTypes = {
    card: [CheckoutSettings.OrderPaymentType.Stripe]
};
